import { WorkflowStep } from "@/types/workflow";
import { StatusButtons } from "./buttons/StatusButtons";
import { AIHelpButton } from "./buttons/AIHelpButton";
import { DocumentGenerateButton } from "./buttons/DocumentGenerateButton";
import { cn } from "@/lib/utils";
import { useIsMobile } from "@/hooks/use-mobile";

export interface WorkflowStepActionsProps {
  step: WorkflowStep;
  caseId: string;
  updating: boolean;
  onStatusUpdate: (status: WorkflowStep["status"]) => Promise<void>;
  onAIHelp: () => void;
  onGenerateDocument: () => void;
  isLoadingAI: boolean;
  isGeneratingDoc: boolean;
}

export function WorkflowStepActions({
  step,
  caseId,
  updating,
  onStatusUpdate,
  onAIHelp,
  onGenerateDocument,
  isLoadingAI,
  isGeneratingDoc
}: WorkflowStepActionsProps) {
  const isMobile = useIsMobile();
  
  const handleStatusUpdate = async (newStatus: WorkflowStep["status"]) => {
    try {
      await onStatusUpdate(newStatus);
    } catch (error) {
      console.error('Error updating status:', error);
    }
  };

  return (
    <div className={cn(
      "flex flex-wrap gap-2",
      isMobile ? "flex-col items-stretch" : "items-center"
    )}>
      <StatusButtons
        status={step.status}
        updating={updating}
        onStatusUpdate={handleStatusUpdate}
      />
      
      <div className={cn(
        "flex gap-2",
        isMobile ? "flex-col" : "flex-row"
      )}>
        <AIHelpButton
          step={step}
          onAIHelp={onAIHelp}
          isLoading={isLoadingAI}
        />
        
        {step.needs_documentation && (
          <DocumentGenerateButton
            stepTitle={step.title}
            caseId={caseId}
            onGenerateDocument={onGenerateDocument}
            isLoading={isGeneratingDoc}
          />
        )}
      </div>
    </div>
  );
}